import React from "react";
import { LoopCircleLoading } from "react-loadingg";
import ReactLoading from "react-loading";



export default function LoaderAnimation(props) {
  // console.log(props)
  
  return  (
    <div
      className="fullCenter d-flex justify-content-center align-items-center"
      style={{ position: "absolute", zIndex: "999999 !important"}}
    >
      <ReactLoading className="mx-auto" type="spin" color="#000000" />
    </div>
  ) 
} 
